import {useSelector} from 'react-redux';
import {routeSelector} from '@app/router/redux';
import {Label} from '@app/components/elements/Label';

export const NDSAuditDetailsNavBar = () => {
  const navbarComponentHeading = useSelector(
    routeSelector.getNavbarComponentHeading(),
  );

  return (
    <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          flexDirection: 'row',
          alignItems: 'baseline',
        }}>
        <Label
          title={navbarComponentHeading}
          variant="h6"
          testID={'superman_admin_navbar_heading'}
          textColor={'#322b7c'}
          fontWeight={'800'}
          hideToolTip
        />
      </div>
    </div>
  );
};
